export const validateSiteName = (name: string): boolean => {
  return name.length > 2;
};

export const validateOrgName = (name: string): boolean => {
  return name.length > 2;
};
